import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import ReactSelect from 'react-select';
import QueryKeys from '../../../utils/QueryKeys';
import './SlideReferenceMaterialsDropdown.scss';
import {
  ReferenceMaterialResponse,
  useReferenceMaterials,
  useSlideReferenceMaterials, useSlideReferenceMaterialsMutation,
} from './SlideReferenceMaterialsDropdown.utils';

type Option = { label: string, value: number };

interface SlideReferenceMaterialsDropdownProps {
  slideId: number;
}

const SlideReferenceMaterialsDropdown = ({ slideId }: SlideReferenceMaterialsDropdownProps) => {
  const queryClient = useQueryClient();
  const { data: referenceMaterials, isLoading: isLoadingReferenceMaterials } = useReferenceMaterials();
  const { data: currentReferenceMaterials, isLoading: isLoadingCurrentMaterials } = useSlideReferenceMaterials(slideId);
  const { mutateAsync } = useSlideReferenceMaterialsMutation(slideId);

  const handleSelectionChange = async (selectedValues: Option[]) => {
    await mutateAsync({ ids: selectedValues.map(option => option.value) });
    await queryClient.invalidateQueries([QueryKeys.Slide, QueryKeys.ReferenceMaterial, slideId]);
  };

  const options = referenceMaterials.map((rm: ReferenceMaterialResponse) => ({ label: rm.title, value: rm.id }));
  const isLoading = isLoadingReferenceMaterials || isLoadingCurrentMaterials;

  return (
    <div className="tw-mb-8 slide-reference-materials-dropdown">
      <label className="tw-mb-2" htmlFor="reference_materials">Reference Materials</label>
      <ReactSelect
        multi
        openOnFocus
        isDisabled={isLoading || referenceMaterials.length === 0}
        name="reference_materials"
        options={options}
        placeholder={isLoading ? 'Loading...' : 'Select reference materials'}
        value={currentReferenceMaterials.map(material => ({ label: material.title, value: material.id }))}
        onChange={handleSelectionChange}
      />
    </div>
  );
};

export default SlideReferenceMaterialsDropdown;
